import Accessibility from './src/accessibility-combined';
export default Accessibility;